import { useCallback } from 'react';

import { CommonActions } from '@react-navigation/native';
import { useNavigationContainerRef, useRouter } from 'expo-router';

import { routes } from 'utils/routing';

export const useStartOrderFromAccountDrawer = () => {
  const rootNavigationRef = useNavigationContainerRef();
  const router = useRouter();

  return useCallback(() => {
    if (!rootNavigationRef.isReady()) {
      router.replace(routes.menu);
      return;
    }

    rootNavigationRef.dispatch(
      CommonActions.reset({
        index: 0,
        routes: [
          {
            name: '(tabs)',
            params: {
              screen: 'menu',
              params: {
                screen: 'index',
              },
            },
          },
        ],
      })
    );
  }, [rootNavigationRef, router]);
};
